export default __webpack_public_path__ + "static/img-a2c9fa22474006776ee5772210f60cfa.png";